(function () {
    'use strict';

    angular
        .module('app')
        .controller('CriticalPathIndexController', CriticalPathIndexController);

    function CriticalPathIndexController($scope, $cookies, $rootScope, $filter, $timeout, $state,
        CriticalPathService, BrandService, SeasonService, SearchHelpService, UserPreferenceService, PatternService, ReportService, SharedData, toaster, cfpLoadingBar) {
        var model = this;
        model.showSearch = true
        model.showCriticalPathDevPatterns = false;
        model.gridOptions = { data: '' };

        model.adoptedStatusList = [];
        $scope.originalColumnState = [];
        $scope.originalColumnOrderState = [];
        $scope.sortObj = [];

        var globalPageNumber = 1;
        var globalPageSize = 50;
        var globalSortColumn = "";
        var globalSortDirection = "";

        $scope.cookieSearch = $cookies.getObject('_cpss');
        $scope.cookieSearchCriteria = typeof $scope.cookieSearch !== 'undefined' ? eval('(' + $scope.cookieSearch.searchTerms + ')') : {};

        model.newSearchObject = {
            name: '',
            type: '',
            dateTimeSaved: '',
            searchTerms: {},
            columns: [],
            columnsOrder: []
        };

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        }

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }

        function setPristine() {
            if ($scope.criticalPathIndexForm) {
                $scope.criticalPathIndexForm.$setPristine();
            }
        }

        /*BrandService.getBrandsByUser().then(function (brandsResponse) {
            model.brands = brandsResponse;
        });

        SeasonService.getSeasons().then(function (seasonsResponse) {
            model.seasons = seasonsResponse;
        });

        CriticalPathService.getCriticalPathHeaderStatusList().then(function (statusData) {
            model.criticalPathHeaderStatusList = statusData;
        });

        CriticalPathService.getCountryOfOriginList().then(function (cntryOfOriginData) {
            model.countryOfOriginList = cntryOfOriginData;
        });

        model.adoptedStatusList.push({ AdoptedStatus: '1', AdoptedStatusName: 'True' }, { AdoptedStatus: '0', AdoptedStatusName: 'False' });

        SearchHelpService.searchGenders().then(function(genders) {
            model.genderData = genders.Results;
        });

        PatternService.getProductLineList().then(function (data) {
            model.productLineList = data;
        });
*/
        //Brand Change Event
        model.brandEvents = function () {
            if (model.BrandId) {
               /* BrandService.getSAPBrandId(model.BrandId).then(function (sapBrandIdResponse) {
                    model.sapBrandId = sapBrandIdResponse;

                    SearchHelpService.searchLasts({ LastName: "*", BrandId: model.sapBrandId }).then(function(lasts) {
                        model.lastData = lasts.Results;
                    });

                    SearchHelpService.searchOutsoles({ OutsoleName: "*", SAPBrandId: model.sapBrandId }).then(function(outsoles) {
                        model.outsoleData = outsoles.Results;
                    });

                    SearchHelpService.searchDivisions({ DivisionName: "*", SAPBrandId: model.sapBrandId }).then(function (divisions) {
                        model.divisionNameData = divisions.Results;
                    });
                });*/
            } else {
                //Empty search help results that require brand
               /* model.lastData = [];
                model.outsoleData = [];
                model.divisionKeyData = [];
                model.divisionNameData = [];*/
            }
        };

        function defaultBranding(b) {
            if (b) {
                model.BrandId = b;
                model.brandEvents();
            }
        }

        SharedData.getUserDefaults().then(function (response) {
            if (response) {
                $scope.defaultBrandId = response.brandId || null;
                $scope.defaultSeasonId = response.seasonId || null;
                $scope.defaultDivisionKey = response.divisionKey || null;
                defaultBranding($scope.defaultBrandId);
            }
            else {
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: "Error getting user preferences data.",
                    timeout: 3000
                });
            }
        });

        model.typeArray = ['Pattern', 'Prototype', 'Commercialization'];
        model.savedSearches = [];
        /*UserPreferenceService.getUserPreferences('UserSearchCP').then(function (response) {
            if (response) {
                for (var i = 0; i < response.length; i++) {
                    //convert JSON string into JSON object
                    var searchCriteria = eval('(' + response[i].PreferenceValue + ')');
                    searchCriteria.userPreferenceId = response[i].UserPreferenceId;
                    searchCriteria.typeName = model.typeArray[searchCriteria.type - 1];
                    model.savedSearches.push(searchCriteria);
                }

                //only works when userpref is ran (on page load) and if cookie exists and is custom search
                if ($scope.cookieSearch) {
                    if ($scope.cookieSearch.index && response.length !== 0) {
                        var cookie = $scope.cookieSearch;

                        model.criticalPathTypeEvents(cookie.type, cookie.name, false, cookie.index);
                        model.getSearchCriteria(cookie.searchTerms);

                        globalPageNumber = model.savedSearches[cookie.index - 1].searchTerms.pageNumber;
                        globalPageSize = model.savedSearches[cookie.index - 1].searchTerms.pageSize;

                        if (cookie.exec) {
                           // model.searchCriticalPaths($scope.criticalPathIndexForm.$invalid);
                        }
                    }
                }
            }

        });*/

        model.getSelected = function (obj) {
            model.deleteArray = []; //service uses this array of id's to delete
            model.deleteArrayNames = [];
            var daLength = 0;
            for (var i = 0; i < obj.length; i++) {
                if (obj[i].selected) {
                    daLength++;
                    model.deleteArray.push(obj[i].userPreferenceId);
                    model.deleteArrayNames.push(obj[i].name);
                }
            }
            if (daLength > 0) {
                model.deleteAll = true;
            } else {
                model.deleteAll = false;
            }
        };

        model.toggleSelectAll = function () {
            var toggleStatus = model.isSelectAll;

            angular.forEach(model.savedSearches,
                function (itm) {
                    itm.selected = toggleStatus;
                });
            model.getSelected(model.savedSearches);
        };

        model.unSelectAll = function () {
            if (model.savedSearches.length < 2) {
                angular.forEach(model.savedSearches,
                    function (itm) {
                        itm.selected = false;
                    });
                model.deleteAll = false;
            }
        };

        model.optionToggled = function (e) {
            model.isSelectAll = model.savedSearches.every(function (itm) {
                return itm.selected;
            });
            model.getSelected(model.savedSearches);
        };

        model.deleteSavedSearches = function () {
            var userPreferenceIds = model.deleteArray.toString();
            UserPreferenceService.deleteUserPreference(userPreferenceIds).then(function (response) {
                toaster.pop({
                    type: 'success',
                    title: 'Delete complete!',
                    body: 'Saved Search successfully removed.',
                    timeout: 3000
                });

                //clear the userdefined reports
                angular.forEach(model.deleteArray, function (key, value) {
                    var index = model.savedSearches.map(function (e) { return e.userPreferenceId }).indexOf(key)
                    if (index > -1) {
                        model.savedSearches.splice(index, 1);
                    }
                });

                if (model.savedSearches.length == 0) {
                    //cookie must be deleted in case of coming back and trying to access the deleted report you may have been on
                    $cookies.remove('_cpss');
                    // if you're on a deleted report, remove fields from view to avoid any conflict
                    if (model.deleteArrayNames.indexOf(model.searchTitle) > -1) {
                        model.cpActive = false;
                    }
                }

                //rebuild array
                $scope.$evalAsync();
            });
        }

        model.windowGridHeight = function () {
            //horizontal orientation in mobile, allow page to stretch instead of allowing a small view on data with scroll
            if (window.innerHeight >= 768) {
                return window.innerHeight - 315;
            } else {
                var size = model.totalRecords < $scope.pageSize ? model.totalRecords : $scope.pageSize;
                return (size * gridOptions.rowHeight) + 46;
            }
        }

        function stateChangeCheck() {
            //used to check for column changes when changing states or navigation away from the grid
            $scope.colHiddenCheck = model.newSearchObject.columns.length !== $scope.originalColumnState.length;
            $scope.colOrderCheck = model.newSearchObject.columnsOrder.length !== $scope.originalColumnOrderState.length;

            if ($scope.colHiddenCheck || $scope.colOrderCheck) {
                return true;
            } else {
                return false;
            }
        }

        model.hideResultsPrompt = function (e) {
            $scope.isPref = false;
            $scope.isState = false;
            if (stateChangeCheck()) {
                $scope.isPref = true;
                $('#confirmHiddenFields').modal('show');
            } else {
                model.hideResults();
            }
        }

        model.hideResults = function () {
            setPristine();

            //reset page numbers so search can resume properly
            globalPageNumber = 1;

            //convert string to json and then reset pageNumber and pageSize
            if ($scope.cookieSearch.searchTerms) {
                var newSearchTerms = angular.fromJson($scope.cookieSearch.searchTerms);
                newSearchTerms.pageNumber = globalPageNumber;
                //update and set createCookie to false so on reload, search doesnt happen
                model.createSaveCookie(newSearchTerms, false);
            }
            model.showGrid = false;
            $rootScope.refine = false;
            $scope.preventNoMore = false;
        }


        $scope.resumeState = 'null';
        $scope.$on('$stateChangeStart', function (event, newState, newStateParams) {
            $scope.isPref = false;
            $scope.isState = false;
            if (stateChangeCheck() && !$scope.preventNoMore) {
                event.preventDefault();
                $scope.isState = true;
                $('#confirmHiddenFields').modal('show');
                $scope.resumeState = newState.name + "(" + JSON.stringify(newStateParams) + ")";
                $scope.preventNoMore = true;
            } else {
                $('#confirmHiddenFields').modal('hide');
            }
        });

        $scope.$on('$locationChangeStart', function (event, newState, newStateParams) {
            $scope.isPref = false;
            $scope.isState = false;
            if (stateChangeCheck() && !$scope.preventNoMore) {
                event.preventDefault();
                $scope.isState = true;
                $('#confirmHiddenFields').modal('show');
                $scope.resumeState = newState.name + "(" + JSON.stringify(newStateParams) + ")";
                $scope.preventNoMore = true;
            } else {
                $('#confirmHiddenFields').modal('hide');
            }
        });

        model.getSearchCriteria = function (obj) {
            var jsonObj;
            if (typeof obj === 'object') {
                jsonObj = obj;
            } else {
                jsonObj = eval('(' + obj.searchTerms + ')');
            }

            for (var key in jsonObj) {
                var value = jsonObj[key];
                model[key] = value;
            }
            //after done
            setPristine();
        }

        model.startSearchOnReload = false;

        model.createSaveCookie = function (data, e) {
            $cookies.remove('_cpss', {});
            $cookies.putObject('_cpss',
                {
                    name: model.searchTitle,
                    type: model.CriticalPathTypeId,
                    index: model.selectedIndex,
                    searchTerms: angular.toJson(data),
                    exec: e
                });
            $scope.cookieSearch = $cookies.getObject('_cpss');
            $scope.cookieSearchCriteria = eval('(' + $scope.cookieSearch.searchTerms + ')');
        };

        //Critical Path Type Event
        model.criticalPathTypeEvents = function(type, name, fast, index) {
            model.selectedIndex = index;
            //set criteria for active classes and names
            model.CriticalPathTypeId = type; //set id to show proper form
            model.searchTitle = name;

            //blank out form
            //model.BrandId = null;
            model.SeasonId = null;
            model.CriticalPathId = null;
            model.CriticalPathName = "";
            model.CriticalPathHeaderStatusId = null;
            model.AdoptedStatus = null;
            model.ProjectName = null;
            model.PatternName = null;
            model.FactoryKey = null;
            model.CntryOrgKey = null;
            model.Last = null;
            model.Outsole = null;
            model.Gender = null;
            model.ProductLine = null;
            model.DivisionKey = null;
            model.DivisionName = null;
            model.StockNumber = null;
            model.LaunchNumber = null;

            //populate saved search form
            if (index) {
                model.isSearchOverwrite = true;
                //index-1 is necessary since ng-click in the tpl.html page wont register 0 index
                model.reportCriteria = model.savedSearches[index - 1];

                //populate saved search form
                model.getSearchCriteria(model.reportCriteria.searchTerms);

                //save report configuration
                model.newSearchObject.searchTerms = model.reportCriteria.searchTerms;
            } else {
                //run default branding to populate branding
                defaultBranding($scope.defaultBrandId);
            }

            //if fast is true, do a search right away
            if (fast) {
                model.searchCriticalPaths($scope.criticalPathIndexForm.$invalid);
            }

            //show the search form
            model.cpActive = true;
        };

        $scope.pagingOptions = [15, 25, 50, 100];

        //function created to re-order the colDefs when the order is changed
        function moveIndex(arr, newIndex, colId) {
            //get old index
            var oldIndex = arr.map(function (e) { return e.field }).indexOf(colId);
            // the object
            var obj = arr[oldIndex];
            //remove old object from position
            arr.splice(oldIndex, 1);
            //reinsert obj here
            arr.splice(newIndex, 0, obj);
        }

        function dateParse(params) {
            if (params) {
                if (typeof params.value !== 'undefined') {
                    return params.value && params.value !== null ? $filter('date')(params.value, "MM/dd/yyyy") : '';
                } else {
                    return params && params !== null ? $filter('date')(params, "MM/dd/yyyy") : '';
                }
            }
        }

        function notePopover(params) {
            if (params) {
                if (typeof params.value !== 'undefined') {
                    if (params.value && params.value !== null) {
                        var eDiv = document.createElement('div');
                        eDiv.innerHTML = '<div class="ag-grid-custom-tooltip-text">' + params.value + '</div><div class="ag-grid-custom-tooltip">' + params.value + '</div>';
                        var hoverElement = eDiv.querySelectorAll('.ag-grid-custom-tooltip-text')[0];
                        var childElement = eDiv.querySelectorAll('.ag-grid-custom-tooltip')[0];

                        hoverElement.addEventListener('mouseover', function () {
                            var bodyRect = document.body.getBoundingClientRect(),
                                elemRect = this.getBoundingClientRect(),
                                offsetTop = elemRect.top,
                                offsetLeft = elemRect.left;
                            childElement.className = childElement.className + ' hover-show';
                            childElement.style.left = offsetLeft + 'px';
                            childElement.style.top = offsetTop + 'px';
                        });

                        hoverElement.addEventListener('mouseout', function () {
                            childElement.className = childElement.className.replace('hover-show', '');
                        });

                        return eDiv;
                    } else {
                        return '';
                    }
                } else {
                    return params;
                }
            }
        }

        function check(params) {
            if (params) {
                if (typeof params.value !== 'undefined') {
                    return params.value && params.value !== null ? '✔' : '';
                } else {
                    return params && params !== null ? '✔' : '';
                }
            }
        }

        function image(params) {
            var img = document.createElement("img");
            img.src = params.value;
            return img;
        }

        var gridOptions = {
            rowData: null,
            rowHeight: 30,
            enableColResize: true,
            enableFilter: false,
            enableSorting: true,
            paginationPageSize: globalPageSize,
            suppressContextMenu: true,
            suppressMultiSort: true,
            suppressSorting: false,
            suppressDragLeaveHidesColumns: true,
            suppressMovableColumns: true,
            suppressRowHoverClass: true,
            suppressColumnMoveAnimation: true,
            showToolPanel: false,
            overlayLoadingTemplate: '<div id="mini-loader"></div>',
            onSortChanged: function (e) {
                var sortObj = gridOptions.api.getSortModel();
                if (sortObj.length) {
                    globalSortColumn = sortObj[0].colId;
                    globalSortDirection = sortObj[0].sort;
                } else {
                    globalSortColumn = "";
                    globalSortDirection = "";
                }

                $scope.sortObj = sortObj;
                $scope.runService();
            },
            onColumnVisible: function (e) {
                var columns = gridOptions.columnApi.getColumnState();
                $scope.selectString = '';
                model.newSearchObject.columns = [];
                angular.forEach(columns, function (value, key) {
                    if (value.hide) {
                        model.newSearchObject.columns.push(value.colId);
                    } else {
                        var comma = $scope.selectString == '' ? '' : ', ';
                        $scope.selectString = $scope.selectString + comma + value.colId;
                    }
                });
            },
            onColumnMoved: function (e) {
                $scope.newIndex = e.toIndex;
                $scope.newIndexName = e.column.colId;
            },
            onDragStopped: function (e) {
                //build something so duplicates arent created
                var index = model.newSearchObject.columnsOrder.map(function (e) { return e.colId; }).indexOf($scope.newIndexName);
                if (index < 0) {
                    model.newSearchObject.columnsOrder.push({ idx: $scope.newIndex, colId: $scope.newIndexName });
                } else {
                    model.newSearchObject.columnsOrder[index].idx = $scope.newIndex;
                }

                moveIndex($scope.gridCols, $scope.newIndex, $scope.newIndexName);

                //needed to update the gridCols array in col configuration
                $scope.$evalAsync();
            }
        };

        $scope.onHideColumns = function (colKey, hide) {
            //if hide = true, visible = false (and vice versa)
            var visible = hide ? false : true;
            gridOptions.columnApi.setColumnVisible(colKey, visible)
        }

        $scope.onBtExport = function (name) {
            gridOptions.api.showLoadingOverlay();
            $scope.runService(true);
        }

        $scope.onBtnBegEnd = function (n) {
            $scope.pageNumber = n;
            $scope.onPageChanged(n);
        }

        $scope.onBtnPrevNext = function (e) {
            $scope.pageNumber = e;
            $scope.onPageChanged(e);
        }

        $scope.onPageChanged = function (e) {
            model.newSearchObject.searchTerms.pageNumber = e;
            globalPageNumber = e;
            $scope.runService();
        }

        $scope.onPageSizeChanged = function (e) {
            model.newSearchObject.searchTerms.pageSize = e;
            globalPageSize = e;
            model.newSearchObject.searchTerms.pageNumber = 1;
            globalPageNumber = 1;
            $scope.runService();
        }

        model.saveSearchPopup = function () {
            model.newSearch = model.searchTitle;
            model.searchNameChanged(model.newSearch);
            $('#saveSearchPopup').modal('show');
            $timeout(function () {
                $('#saveSearchPopup input[type=text]').focus();
                $('#saveSearchPopup input[type=text]').select();
            }, 0);
        }

        model.searchNameChanged = function (newSearch) {
            if (model.newSearch != '') {
                model.isNoSearchName = false;
            }

            if (model.customSearchName == newSearch) {
                model.isSearchOverwrite = true;
            }
            else {
                model.isSearchOverwrite = false;
            }

            for (var i = 0; i < model.savedSearches.length; i++) {
                var userSearchModel = model.savedSearches[i];
                if (newSearch == userSearchModel.name) {
                    model.isSearchOverwrite = true;
                    //assign id to current report
                    model.UserPreferenceId = userSearchModel.userPreferenceId;
                }
            }
        }

        var widthXS = 60;
        var widthS = 110;
        var widthM = 170;
        var widthL = 250;
        var widthXL = 375;
        var globalRowHeight = 35;
        var widthImage = 76;

        //Search Event
        model.searchCriticalPaths = function (isFormInvalid) {
            if (!isFormInvalid) {
                if (document.querySelector('#myGrid').children.length == 0) {
                    cfpLoadingBar.start();
                }

                //set critical path search model data
                if (model.CriticalPathTypeId === 1) {
                    model.criticalPathSearchData = {
                        BrandId: model.BrandId || null,
                        SeasonId: model.SeasonId || null,
                        CriticalPathId: model.CriticalPathId || null,
                        CriticalPathName: model.CriticalPathName || "",
                        CriticalPathHeaderStatusId: model.CriticalPathHeaderStatusId || null,
                        AdoptedYN: model.AdoptedStatus || null,
                        ProjectName: model.ProjectName || null,
                        PatternName: model.PatternName || null,
                        FactoryKey: model.FactoryKey || null,
                        Last: model.Last || null,
                        Outsole: model.Outsole || null,
                        Gender: model.Gender || null,
                        ProductLine: model.ProductLine || null,
                        DivisionKey: model.DivisionKey || null,
                        Division: model.DivisionName || null,
                        LaunchNumber: model.LaunchNumber || null,
                        StockNumber: model.StockNumber || null,
                    };

                    gridOptions.columnDefs = [
                        { field: 'CriticalPathDevPatternId', headerName: 'Id', hide: false, width: widthXS, menuTabs: [] },
                        { field: 'CriticalPathHeaderStatusName', headerName: 'Status', hide: false, width: widthS, menuTabs: [] },
                        { field: 'CriticalPathDevPatternName', headerName: 'Name', hide: false, width: widthXL, menuTabs: [] },
                        { field: 'ProjectName', headerName: 'Project Name', hide: false, width: widthL, menuTabs: [] },
                        { field: 'PatternName', headerName: 'Pattern Name', hide: false, menuTabs: [] },
                        { field: 'BrandName', headerName: 'Brand Name', hide: false, width: widthL, menuTabs: [] },
                        { field: 'Notes', headerName: 'Notes', hide: false, cellRenderer: notePopover, width: widthL, menuTabs: [] },
                        { field: 'Gender', headerName: 'Gender', hide: false, width: widthS, menuTabs: [] },
                        { field: 'DevelopmentType', headerName: 'Development Type', hide: false, width: widthL, menuTabs: [] },
                        { field: 'SeasonName', headerName: 'Season Name', hide: false, menuTabs: [] },
                        { field: 'SeasonYear', headerName: 'Season Year', hide: false, width: widthS, menuTabs: [] },
                        { field: 'FactoryKey', headerName: 'Factory Key', hide: false, width: widthS, menuTabs: [] },
                        { field: 'FactoryName', headerName: 'Factory Name', hide: false, menuTabs: [] },
                        { field: 'CntryOrgKey', headerName: 'Cntry Org Key', hide: false, width: widthM, menuTabs: [] },
                        { field: 'DivisionName', headerName: 'Division Name', hide: false, menuTabs: [] },
                        { field: 'LaunchDescription', headerName: 'Launch Description', hide: false, menuTabs: [] },
                        { field: 'CreatedOn', headerName: 'Created On', hide: false, cellRenderer: dateParse, width: widthM, menuTabs: [] },
                        { field: 'CreatedByName', headerName: 'Created By', hide: false, menuTabs: [] },
                        { field: 'ChangedOn', headerName: 'Changed On', hide: false, cellRenderer: dateParse, width: widthM, menuTabs: [] },
                        { field: 'ChangedByName', headerName: 'Changed By', hide: false, menuTabs: [] }
                    ];

                    gridOptions.onRowClicked = function (event) {
                        if (!event.event.ctrlKey) {
                            $state.go('criticalPathDevPatternEdit', { 'patternSeasonalId': event.data.PatternSeasonalId });
                        } else {
                            window.open(window.location.origin + '/criticalPathDevPatternEdit/' + event.data.PatternSeasonalId, '_blank');
                        }
                    };
                }

                if (model.CriticalPathTypeId == 2) {
                    model.criticalPathSearchData = {
                        BrandId: model.BrandId || null,
                        SeasonId: model.SeasonId || null,
                        CriticalPathId: model.CriticalPathId || null,
                        CriticalPathName: model.CriticalPathName || "",
                        CriticalPathHeaderStatusId: model.CriticalPathHeaderStatusId || null,
                        AdoptedYN: model.AdoptedStatus || null,
                        ProjectName: model.ProjectName || null,
                        PatternName: model.PatternName || null,
                        FactoryKey: model.FactoryKey || null,
                        Country: model.CntryOrgKey || null,
                        Last: model.Last || null,
                        Outsole: model.Outsole || null,
                        Gender: model.Gender || null,
                        ProductLine: model.ProductLine || null,
                        DivisionKey: model.DivisionKey || null,
                        Division: model.DivisionName || null,
                        StockNumber: model.StockNumber || null,
                        LaunchNumber: model.LaunchNumber || null
                    };

                    gridOptions.columnDefs = [
                        { field: 'CriticalPathDevPrototypeId', headerName: 'Id', hide: false, width: widthXS, menuTabs: [] },
                        { field: 'CriticalPathHeaderStatusName', headerName: 'Status', hide: false, width: widthS, menuTabs: [] },
                        { field: 'CriticalPathDevPrototypeName', headerName: 'Name', hide: false, width: widthXL, menuTabs: [] },
                        { field: 'PatternName', headerName: 'Pattern', hide: false, menuTabs: [] },
                        { field: 'BrandName', headerName: 'Brand', hide: false, width: widthL, menuTabs: [] },
                        { field: 'Notes', headerName: 'Notes', hide: false, cellRenderer: notePopover, width: widthL, menuTabs: [] },
                        { field: 'Gender', headerName: 'Gender', hide: false, width: widthS, menuTabs: [] },
                        { field: 'DevelopmentType', headerName: 'Development Type', hide: false, width: widthL, menuTabs: [] },
                        { field: 'StockNumber', headerName: 'Stock Number', hide: false, menuTabs: [] },
                        { field: 'DivisionKey', headerName: 'Division Key', hide: false, menuTabs: [] },
                        { field: 'DivisionName', headerName: 'Division Name', hide: false, menuTabs: [] },
                        { field: 'OriginalSeasonName', headerName: 'Original Season', hide: false, menuTabs: [] },
                        { field: 'AllSeasons', headerName: 'All Seasons', hide: false, width: widthL, menuTabs: [] },
                        { field: 'FactoryKey', headerName: 'Factory Key', hide: false, width: widthS, menuTabs: [] },
                        { field: 'FactoryName', headerName: 'Factory Name', hide: false, width: widthL, menuTabs: [] },
                        { field: 'FactoryGroupName', headerName: 'Factory Group', hide: false, width: widthL, menuTabs: [] },
                        { field: 'CtryOfOrig', headerName: 'Cntry Org Key', hide: false, width: widthM, menuTabs: [] },
                        { field: 'LaunchDescription', headerName: 'Launch', hide: false, menuTabs: [] },
                        { field: 'CreatedOn', headerName: 'Created On', hide: false, cellRenderer: dateParse, width: widthM, menuTabs: [] },
                        { field: 'CreatedByName', headerName: 'Created By', hide: false, menuTabs: [] },
                        { field: 'ChangedOn', headerName: 'Changed On', hide: false, cellRenderer: dateParse, width: widthM, menuTabs: [] },
                        { field: 'ChangedByName', headerName: 'Changed By', hide: false, menuTabs: [] }
                    ];

                    gridOptions.onRowClicked = function (event) {
                        if (!event.event.ctrlKey) {
                            $state.go('criticalPathDevPrototypeEdit', { 'devPrototypeId': event.data.CriticalPathDevPrototypeId });
                        } else {
                            window.open(window.location.origin + '/criticalPathDevPrototypeEdit/' + event.data.CriticalPathDevPrototypeId, '_blank');
                        }
                    };
                }

                if (model.CriticalPathTypeId === 3) {
                    model.criticalPathSearchData = {
                        BrandId: model.BrandId || null,
                        SeasonId: model.SeasonId || null,
                        CriticalPathId: model.CriticalPathId || null,
                        CriticalPathName: model.CriticalPathName || "",
                        CriticalPathHeaderStatusId: model.CriticalPathHeaderStatusId || null,
                        AdoptedYN: model.AdoptedStatus || null,
                        ProjectName: model.ProjectName || null,
                        PatternName: model.PatternName || null,
                        FactoryKey: model.FactoryKey || null,
                        Country: model.CntryOrgKey || null,
                        Last: model.Last || null,
                        Outsole: model.Outsole || null,
                        Gender: model.Gender || null,
                        ProductLine: model.ProductLine || null,
                        DivisionKey: model.DivisionKey || null,
                        Division: model.DivisionName || null,
                        StockNumber: model.StockNumber || null,
                        LaunchNumber: model.LaunchNumber || null,
                        OriginalSeasonId: model.OriginalSeasonId || null
                    };

                    gridOptions.columnDefs = [
                        { field: 'CriticalPathCommercializationId', headerName: 'Id', hide: false, width: widthXS, menuTabs: [] },
                        { field: 'CriticalPathHeaderStatusName', headerName: 'Status', hide: false, width: widthS, menuTabs: [] },
                        { field: 'CriticalPathName', headerName: 'Name', hide: false, width: widthXL, menuTabs: [] },
                        { field: 'ProjectName', headerName: 'Project Name', hide: false, width: widthL, menuTabs: [] },
                        { field: 'PatternName', headerName: 'Pattern Name', hide: false, menuTabs: [] },
                        { field: 'BrandName', headerName: 'Brand Name', hide: false, width: widthL, menuTabs: [] },
                        { field: 'SeasonName', headerName: 'Season Name', hide: false, width: widthL, menuTabs: [] },
                        { field: 'SeasonYear', headerName: 'Season Year', hide: false, width: widthS, menuTabs: [] },
                        { field: 'Notes', headerName: 'Notes', hide: false, cellRenderer: notePopover, width: widthL, menuTabs: [] },
                        { field: 'Gender', headerName: 'Gender', hide: false, width: widthS, menuTabs: [] },
                        { field: 'DevelopmentType', headerName: 'Development Type', hide: false, width: widthL, menuTabs: [] },
                        { field: 'StockNumber', headerName: 'Stock Number', hide: false, menuTabs: [] },
                        { field: 'DivisionKey', headerName: 'Division Key', hide: false, menuTabs: [] },
                        { field: 'DivisionName', headerName: 'Division Name', hide: false, menuTabs: [] },
                        { field: 'FactoryKey', headerName: 'Factory Key', hide: false, width: widthS, menuTabs: [] },
                        { field: 'FactoryName', headerName: 'Factory Name', hide: false, width: widthL, menuTabs: [] },
                        { field: 'CntryOrgKey', headerName: 'Cntry Org Key', hide: false, width: widthM, menuTabs: [] },
                        //{ field: 'LaunchDescription', headerName: 'Launch Description', hide: true, menuTabs: [] }, //commented out due to insufficient resources to implement at this time
                        { field: 'CreatedOn', headerName: 'Created On', hide: false, cellRenderer: dateParse, width: widthM, menuTabs: [] },
                        { field: 'CreatedByName', headerName: 'Created By', hide: false, menuTabs: [] },
                        { field: 'ChangedOn', headerName: 'Changed On', hide: false, cellRenderer: dateParse, width: widthM, menuTabs: [] },
                        { field: 'ChangedByName', headerName: 'Changed By', hide: false, menuTabs: [] }
                    ];

                    gridOptions.onRowClicked = function (event) {
                        if (!event.event.ctrlKey) {
                            $state.go('criticalPathCommercializationEdit', { 'criticalPathCommercializationId': event.data.CriticalPathCommercializationId });
                        } else {
                            window.open(window.location.origin + '/criticalPathCommercializationEdit/' + event.data.CriticalPathCommercializationId, '_blank');
                        }
                    };

                }

                //set newSearchObject search terms to use for saving searches
                model.newSearchObject.searchTerms = model.criticalPathSearchData;
                model.showGrid = true;
                $rootScope.refine = model.hideResultsPrompt;
                $scope.gridCols = gridOptions.columnDefs;
                $scope.runService();
            } else {
                $scope.criticalPathIndexForm.$setSubmitted();
            }
        }
        $scope.runService = function (report) {

            var gridDiv = document.querySelector('#myGrid');

            if (gridDiv.children.length > 0 && !report) {
                gridOptions.api.showLoadingOverlay();
            }

            //what service to run
            var service = '';
            if (model.CriticalPathTypeId == 1) {
                service = CriticalPathService.getCriticalPathDevPatterns;
            }

            if (model.CriticalPathTypeId == 2) {
                service = CriticalPathService.getCriticalPathDevProtos;
            }

            if (model.CriticalPathTypeId == 3) {
                service = CriticalPathService.getCriticalPathCommercializations;
            }
            //set the report model search terms page number and size for proper cookie save
            model.newSearchObject.searchTerms.pageNumber = globalPageNumber;
            model.newSearchObject.searchTerms.pageSize = globalPageSize;
            model.newSearchObject.searchTerms.sortColumn = $scope.cookieSearchCriteria.sortColumn || globalSortColumn;
            model.newSearchObject.searchTerms.sortDirection = $scope.cookieSearchCriteria.sortDirection || globalSortDirection;

            if (report) { //if this is an excel export, we must re-run a wide open query to export all results
                var originalGlobalPageNumber = globalPageNumber;
                var originalGlobalPageSize = globalPageSize;
                globalPageNumber = 1;
                globalPageSize = model.totalRecords;
            } else {
                //if its a custom report and not a report
                if (typeof model.selectedIndex !== 'undefined' && model.savedSearches && model.savedSearches.length > model.selectedIndex) {
                    //get hidden columns from custom report and mark them hidden
                    angular.forEach(gridOptions.columnDefs, function (key, value) {
                        if (model.savedSearches[model.selectedIndex].columns.indexOf(key.field) > -1) {
                            key.hide = true;
                        }
                    });
                }

                // on run report, before try, save cookie, but dont run the search, only bring up criteria
                model.createSaveCookie(model.newSearchObject.searchTerms, false);
            }

            service(model.newSearchObject.searchTerms, globalPageNumber, globalPageSize, globalSortColumn, globalSortDirection).then(function (response) {
                if (response && response.length > 0) {
                    model.reportModel = response;
                    if (!report) {
                        model.totalRecords = response[0].RecordCount;
                        $scope.pageSize = globalPageSize;
                        $scope.pageNumber = globalPageNumber;
                        $scope.totalPages = Math.ceil(model.totalRecords / globalPageSize);

                        $scope.lastRecord = $scope.pageNumber == $scope.totalPages ? model.totalRecords : $scope.pageNumber * $scope.pageSize;
                        $scope.firstRecord = $scope.pageNumber == $scope.totalPages ? (($scope.pageNumber - 1) * $scope.pageSize) + 1 : $scope.lastRecord - $scope.pageSize + 1;

                        //setting the sort up if there was sorting to begin with
                        if ($scope.sortObj.length > 0) {
                            var colId = $scope.sortObj[0].colId,
                                sort = $scope.sortObj[0].sort;
                            angular.forEach(gridOptions.columnDefs, function (k, v) {
                                if (k.field == colId) {
                                    k.sort = sort;
                                };
                            });
                            $scope.lastSortedCol = colId;
                        } else {
                            if ($scope.cookieSearchCriteria.sortColumn && $scope.cookieSearchCriteria.sortDirection) {
                                angular.forEach(gridOptions.columnDefs, function (k, v) {
                                    if (k.field == $scope.cookieSearchCriteria.sortColumn) {
                                        k.sort = $scope.cookieSearchCriteria.sortDirection;
                                    };
                                });
                            } else {
                                angular.forEach(gridOptions.columnDefs, function (k, v) {
                                    if (k.field == $scope.lastSortedCol) {
                                        k.sort = '';
                                    };
                                });
                            }
                        }

                        //if doesnt exist make new grid
                        //if does exist, set column defs
                        if (gridDiv.children.length == 0) {
                            new agGrid.Grid(gridDiv, gridOptions);
                        } else {
                            gridOptions.api.setColumnDefs(gridOptions.columnDefs);
                        }

                        //bind data
                        gridOptions.api.setRowData(response);
                        gridOptions.api.hideOverlay();

                        setPristine();

                        //get first visible column to reset scroll
                        $scope.colScrollTo = '';
                        var matchFound = false;
                        angular.forEach(gridOptions.columnDefs, function (key) {
                            if (!matchFound) {
                                if (!key.hide) {
                                    matchFound = true;
                                    $scope.colScrollTo = key.field;
                                }
                            }
                        });

                        //scroll to beginning
                        gridOptions.api.ensureColumnVisible($scope.colScrollTo);

                        //handle column ordering on grid render
                        $scope.originalColumnOrderState = [];
                        model.newSearchObject.columnsOrder = [];
                        if (typeof model.selectedIndex !== 'undefined' && model.newSearchObject.columnsOrder) {
                            //get row column from custom report and move it to its spot
                            angular.forEach(gridOptions.columnDefs, function (key, value) {
                                var index = model.newSearchObject.columnsOrder.map(function (e) { return e.colId }).indexOf(key.field)
                                if (index > -1) {
                                    var colId = model.newSearchObject.columnsOrder[index].colId;
                                    var colIndex = model.newSearchObject.columnsOrder[index].idx;
                                    gridOptions.columnApi.moveColumn(colId, colIndex);

                                    moveIndex($scope.gridCols, colIndex, colId);

                                    //rebuld columnsorder objects to reserve save state if nothing changed
                                    var obj = { idx: colIndex, colId: colId };
                                    $scope.originalColumnOrderState.push(obj);
                                    model.newSearchObject.columnsOrder.push(obj);
                                }
                            });

                            ///needed to update the gridCols array in col configuration
                            $scope.$evalAsync();
                        }

                        // onsuccess save it to execute the search on reload
                        model.createSaveCookie(model.newSearchObject.searchTerms, true);

                        //populate original hidden columns when grid was loaded
                        //this is used to check if a change has been made from the original column state.
                        //this same function (without the model.newSearchObject.columns.push()) also runs in the hideResultsPrompt function;
                        $scope.originalColumnState = [];
                        var columns = gridOptions.columnApi.getColumnState();
                        model.newSearchObject.columns = [];
                        angular.forEach(columns, function (value, key) {
                            if (value.hide) {
                                $scope.originalColumnState.push(value.colId);
                                model.newSearchObject.columns.push(value.colId);
                            }
                        });

                        cfpLoadingBar.complete();
                    } else {
                        var dateCheckRegex = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d)/;
                        for (var i = 0; i < response.length; i++) {
                            angular.forEach(response[i], function (value, key) {
                                if (value !== null) {
                                    if (dateCheckRegex.test(value)) {
                                        response[i][key] = dateParse(value);
                                    };
                                    if (value == true || value == false) {
                                        response[i][key] = check(value);
                                    };
                                } else {
                                    response[i][key] = '';
                                }
                            });
                        }

                        //build the shown columns if they dont already exist
                        if (!$scope.selectString) {
                            var columns = gridOptions.columnApi.getColumnState();
                            $scope.selectString = '';
                            angular.forEach(columns, function (value, key) {
                                if (!value.hide) {
                                    var comma = $scope.selectString == '' ? '' : ', ';
                                    $scope.selectString = $scope.selectString + comma + value.colId;
                                }
                            });
                        };

                        //create file name and export using alasql
                        var fileName = $scope.reportName.replace(/\s/g, '-') + '-Export'; //xlsx is required
                        alasql('SELECT ' + $scope.selectString + ' INTO XLSX("' + fileName + '.xlsx",?) FROM ?', [{ headers: true }, response]);
                        //set global variables to what they were before the export
                        globalPageNumber = originalGlobalPageNumber;
                        globalPageSize = originalGlobalPageSize;
                        //hide loading overlay
                        gridOptions.api.hideOverlay();
                    }
                }
                else {
                    toaster.pop({
                        type: 'warning',
                        title: 'Alert!',
                        body: 'No data was found matching this search criteria.',
                        timeout: 3000
                    });
                    model.hideResults();
                    cfpLoadingBar.complete();
                }

            },
                function (error, status) {
                    toaster.pop({
                        type: 'warning',
                        title: 'Alert!',
                        body: 'No data was found matching this search criteria.',
                        timeout: 3000
                    });
                    model.hideResults();
                    cfpLoadingBar.complete();
                });
        };
        //end of runservice

        // if there is a cookie for a save search, do the work to get that search
        if ($scope.cookieSearch) {
            if (!$scope.cookieSearch.index) {
                model.criticalPathTypeEvents($scope.cookieSearch.type, $scope.cookieSearch.name, false, $scope.cookieSearch.index);

                var searchTerms = eval('(' + $scope.cookieSearch.searchTerms + ')');
                model.getSearchCriteria(searchTerms);

                globalPageNumber = searchTerms.pageNumber;
                globalPageSize = searchTerms.pageSize;

                if ($scope.cookieSearch.exec) {
                 //   model.searchCriticalPaths(criticalPathIndexForm.$invalid);
                }
            }
        }

        model.saveSearch = function (newSearch) {
            if (!model.newSearch || model.newSearch.trim() == '') {
                model.isNoSearchName = true;
                return;
            }

            model.newSearchObject.name = model.newSearch;
            model.newSearchObject.type = model.CriticalPathTypeId;
            model.newSearchObject.dateTimeSaved = new Date();
            model.newSearchObject.CriticalPathTypeId = model.CriticalPathTypeId;

            var userPreferenceModel = {
                UserPreferenceId: model.UserPreferenceId,
                PreferenceName: "UserSearchCP",
                model: angular.toJson(model.newSearchObject)
            }

            if (!model.isSearchOverwrite) {
                userPreferenceModel.UserPreferenceId = 0;
            }

            UserPreferenceService.updateUserPreferences(userPreferenceModel).then(function (response) {
                toaster.pop({
                    type: 'success',
                    title: 'Save complete!',
                    body: 'Search successfully saved.',
                    timeout: 3000
                });

                $('#saveSearchPopup').modal('hide');

                //reset original state since this is a saved report now, and not populated from default settings
                $scope.originalColumnState = model.newSearchObject.columns;
                $scope.originalColumnOrderState = model.newSearchObject.columnsOrder;

                //after save, repopulate saved searches without reloading entire page
                UserPreferenceService.getUserPreferences('UserSearchCP').then(function (response) {
                    if (response) {
                        model.savedSearches = [];
                        for (var i = 0; i < response.length; i++) {
                            //convert JSON string into JSON object
                            var searchCriteria = eval('(' + response[i].PreferenceValue + ')');
                            //set up id before sending to the array
                            searchCriteria.userPreferenceId = response[i].UserPreferenceId;
                            searchCriteria.typeName = model.typeArray[searchCriteria.type - 1];
                            model.savedSearches.push(searchCriteria);

                            if (model.newSearch == searchCriteria.name) {
                                model.searchTitle = model.newSearch;
                                model.selectedIndex = i;
                            }

                        }
                        model.createSaveCookie(model.newSearchObject.searchTerms, true);
                    }
                });
            });

        }; //end saveSearch()


        model.Report = function () {
            //Report
            model.parameterValues = [];
            //Critical Path Dev Pattern Report
            if (model.CriticalPathTypeId == 1) {
                angular.forEach(model.reportModel, function (criticalPathDevPatternRow) {
                    model.parameterValues.push(criticalPathDevPatternRow.CriticalPathDevPatternId);
                });

                var reportName = 'DevPatternCriticalPath';
                var parameterName = 'CriticalPathDevPatternId';
                var parameterValuesList = JSON.stringify(model.parameterValues);

                ReportService.generateReport(reportName, parameterName, parameterValuesList).then(function (response) {
                    var file = new Blob([response], { type: 'application/pdf' });
                    saveAs(file, reportName + '.pdf')

                }, function (error, status) {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'There was an error generating the report. Please contact your system administrator.',
                        timeout: 5000
                    });

                });
            }

            //Critical Path Dev Colorway Report
            if (model.CriticalPathTypeId == 2) {
                angular.forEach(model.reportModel, function (criticalPathDevProtoRow) {
                    model.parameterValues.push(criticalPathDevProtoRow.CriticalPathDevPrototypeId);
                });

                var reportName = 'DevProtoCriticalPath';
                var parameterName = 'CriticalPathDevPrototypeId';
                var parameterValuesList = JSON.stringify(model.parameterValues);

                ReportService.generateReport(reportName, parameterName, parameterValuesList).then(function (response) {
                    var file = new Blob([response], { type: 'application/pdf' });
                    saveAs(file, reportName + '.pdf')

                }, function (error, status) {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'There was an error generating the report. Please contact your system administrator.',
                        timeout: 5000
                    });
                });
            }

            //Critical Path Dev Colorway Report
            if (model.CriticalPathTypeId == 3) {
                angular.forEach(model.reportModel, function (criticalCommercializationRow) {
                    model.parameterValues.push(criticalCommercializationRow.CriticalPathCommercializationId);
                });

                var reportName = 'CommercializationCriticalPath';
                var parameterName = 'CriticalPathCommercializationId';
                var parameterValuesList = JSON.stringify(model.parameterValues);

                ReportService.generateReport(reportName, parameterName, parameterValuesList).then(function (response) {
                    var file = new Blob([response], { type: 'application/pdf' });
                    saveAs(file, reportName + '.pdf')

                }, function (error, status) {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'There was an error generating the report. Please contact your system administrator.',
                        timeout: 5000
                    });

                });
            }

        }

        function getMsSinceMidnight(d) {
            var e = new Date(d);
            return d - e.setHours(0, 0, 0, 0);
        }
    }
})();
